var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHisIconsPlusDisable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#8F9BB3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.083 6.417h-3.5v-3.5c0-.323-.261-.584-.583-.584-.322 0-.583.261-.583.584v3.5h-3.5c-.322 0-.584.26-.584.583 0 .323.262.583.584.583h3.5v3.5c0 .323.261.584.583.584.322 0 .583-.261.583-.584v-3.5h3.5c.322 0 .584-.26.584-.583 0-.323-.262-.583-.584-.583",
    transform: "translate(-538 -126) translate(526 117) translate(12 9)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHisIconsPlusDisable);
export default __webpack_public_path__ + "static/media/icon-his-icons-plus-disable.bc32c384.svg";
export { ForwardRef as ReactComponent };